import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Grid } from '@mui/material';

const ActionButton = ({ link, text, color, justify }) => {
  return (
    <Grid container spacing={2} justifyContent={justify}>
      <Grid item>
        <Box mt={'20px'}>
          <Button variant="contained" color={color} href={link} rel="opener" style={{ padding: '26px 50px' }}>
            {text}
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

ActionButton.propTypes = {
  link: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  color: PropTypes.oneOf(['primary', 'secondary']),
  justify: PropTypes.oneOf(['center', 'flex-start']),
};

ActionButton.defaultProps = {
  color: 'primary',
  justify: 'center',
};

export default ActionButton;
